import { AlertCircle, RefreshCw } from "lucide-react";

type DashboardErrorStateProps = {
  message: string;
  onRetry: () => void;
};

export function DashboardErrorState({
  message,
  onRetry,
}: DashboardErrorStateProps) {
  return (
    <div className="rounded-lg border border-red-200 bg-white p-6 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-red-50 text-red-600">
          <AlertCircle size={22} />
        </div>
        <div className="min-w-0">
          <h2 className="m-0 text-base font-bold text-slate-950">
            Dashboard report unavailable
          </h2>
          <p className="mt-1 text-sm font-medium text-slate-600">{message}</p>
          <button
            type="button"
            className="mt-4 inline-flex h-9 items-center gap-2 rounded-md bg-blue-600 px-4 text-sm font-bold text-white hover:bg-blue-700"
            onClick={onRetry}
          >
            <RefreshCw size={16} />
            Retry
          </button>
        </div>
      </div>
    </div>
  );
}
